import { parsePrintDispPresOption } from 'src/app/services/api-service/parameters/PRN001Params';
import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DosageDTO, HistApi } from 'src/app/services/api-service/hist/hist-api';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { UserCache } from 'src/app/services/user-cache';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import * as QRCode from 'qrcode';
import { HistEditOption } from 'src/app/services/api-service/hist/hist-edit-option';
import { HistService } from 'src/app/hist/services/hist.service';
import { NHIRegIC } from 'src/app/services/api-service/register/nhiRegIc';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { Hspid } from 'src/app/services/api-service/hspid/hspid';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { fixSpecialChar, isSpecialChar } from 'src/app/shared/utilities';
import { OrderDispensingTypeEnum } from 'src/app/enums/DispensingTypeEnum';
import { NHIHistory } from 'src/app/services/api-service/NHI/nhiHistory';
import { RepeatedPrescriptionDto } from 'src/app/services/api-service/hist/whole-large-hist';


/** 連續處方箋 */
@Component({
  selector: 'app-labs-outclinic-report',
  templateUrl: './labs-outclinic-report.component.html',
  styleUrls: ['./labs-outclinic-report.component.css']
})
export class LabsOutclinicReportComponent implements OnInit {
  //連續報表紙寬度一半
  sizePageLetterHalf = {
    // width: 28.7, //cm
    // height: 20 //cm
    // width: 11, //cm
    width: 9.8, //cm
    height: 14 //cm
  };
  paddingPageLetterHalf = {
    top: 0, //cm
    right: 0, //cm
    bottom: 0, //cm
    left: 0 //cm
  };

  @ViewChild('reportContainer')
  reportContainer: ElementRef<HTMLDivElement>;
  @ViewChild('reportContainerLetterHalf')
  reportContainerLetterHalf: ElementRef<HTMLDivElement>;
  hist: WholeHist;
  ic: NHIRegIC;
  nhiHist: NHIHistory;
  clinic: Clinic;
  @ViewChild('qrcodeImg')
  qrcodeImg: ElementRef<HTMLImageElement>
  @ViewChild('qrcode2Img')
  qrcode2Img: ElementRef<HTMLImageElement>
  @ViewChild('qrcodeItreatnumImg')
  qrcodeItreatnumImg: ElementRef<HTMLImageElement>
  @ViewChild('qrcodeItreatnum2Img')
  qrcodeItreatnum2Img: ElementRef<HTMLImageElement>
  wholeHist: RepeatedPrescriptionDto;
  isopenQRcode = false;
  textToEncode = 'sadasdas233dasdADD';
  normalCheck: string = 'V';
  cntPresCheck: string = '';
  repeatprehcaModule: { InitModule: number, InitSession: number }
  medcodeName: string;
  regdateString: string;
  clinicAddress: string;
  space = '　';
  isPrintItreatnum = true;
  isPrintRegDateTime = true;
  isPrintQRCode = true;
  isPrintBarcode = true;
  temphrx: HistOrder[] = [];
  labHospInfo: Hspid[] = [];
  printOutByLab: HistOrder[][] = [];
  isLetterHalf = false;

  get isPrintAnyDispPresOption(): boolean {
    return this.isPrintItreatnum || this.isPrintRegDateTime || this.isPrintQRCode || this.isPrintBarcode;
  }

  // 免部分負擔代碼白名單
  private readonly exemptApartCodes = new Set([
    '001', '002', '003', '004', '005', '006', '007', '008', '009',
    '012', '013',
    '801', '802',
    '901', '902', '903', '904', '905', '906', '907',
    '908', '909', '910', '911', '912', '913'
  ]);

  // 判斷是否為免部分負擔代碼
  isExemptApartCode(code: string): boolean {
    return this.exemptApartCodes.has((code ?? '').trim());
  }


  @Input()
  set regId(id) {
    this.setRegId(id);
  }
  constructor(
    private api: HistApi,
    private histService: HistService,
    private clinicDataService: ClinicDataService) {
  }
  get editOptions(): HistEditOption {
    return this.histService.EditOptions;
  }
  get dosages(): DosageDTO[] {
    return this.editOptions.dosage;
  }

  async ngOnInit() {

    var st = document.createElement('style');
    st.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report table{ border:1px solid black; border-collapse: collapse; }\n' +
      '.pres-report table td, table th { border: 1px solid black; padding-left: 2px;padding-right: 2px;}\n' +
      '.pres-report table tr:first-child th { border-top: 0; }\n' +
      '.pres-report table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report table tr td:last-child, table tr th:last-child { border-right: 0; }'
    ));
    // 兩個版面容器各持有一份樣式節點。appendChild 是搬移而非複製，共用同一個節點會讓
    // 先 append 的容器失去 .pres-report 框線；getHtml() 匯出的是容器 innerHTML，
    // 樣式必須留在各自容器內才會隨送印 HTML 一起送出。
    setTimeout(() => {
      this.reportContainer.nativeElement.appendChild(st);
      this.reportContainerLetterHalf.nativeElement.appendChild(st.cloneNode(true));
    }, 0);
    //st.outerHTML
  }
  async setRegId(regId: number) {
    //1=A4, 2=LetterHalf
    var param = await this.clinicDataService.getParam("PRN001");
    this.isLetterHalf = param?.ExamPresType == 2 ? true : false;
    const printOption = parsePrintDispPresOption(param?.PrintDispPresOption);
    this.isPrintItreatnum = printOption.Itreatnum;
    this.isPrintRegDateTime = printOption.RegDateTime;
    this.isPrintQRCode = printOption.QRCode;
    this.isPrintBarcode = printOption.Barcode;
    this.clinic = UserCache.getLoginUser().Clinic;
    this.clinicAddress = (this.clinic.City || '') + (this.clinic.Area || '') + (this.clinic.Street || '');

    this.wholeHist = await this.api.getLabOutClinicReport(regId, this.clinic);
    this.hist = this.wholeHist.WholeHist;
    // 委外檢驗單，要排除院內自檢的檢驗項目(x.DispTP != OrderDispensingTypeEnum.T0_Clinic)
    this.hist.Hist.HRxs = this.hist.Hist.HRxs.filter(x => (x.RxType == 6 || x.RxType == 7) && x.DispTP != OrderDispensingTypeEnum.T0_Clinic);
    this.ic = this.wholeHist.NHIRegIC;
    this.nhiHist = this.wholeHist.NHIHistory;
    //有發生案例是就醫識別碼中有特殊字元，所以要處理，不然會造成BarCode印製失敗。
    //案例: g  F128Y9S3BCQCWC\u0000\u0000\u0000
    if (isSpecialChar(this.ic.Itreatnum)) {
      this.ic.Itreatnum = fixSpecialChar(this.ic.Itreatnum);
    }
    this.labHospInfo = this.wholeHist.HspidList.length > 0 ? this.wholeHist.HspidList : [];
    this.splitByLab();
  }
  getHtml() {
    if (this.ic && this.ic.Itreatnum) {
      this.generateQRCode(this.ic?.Itreatnum, 3);
    }

    let html = '';
    if (this.isLetterHalf) {
      html = this.reportContainerLetterHalf.nativeElement.innerHTML;
    } else {
      html = this.reportContainer.nativeElement.innerHTML;
    }
    return html;
  }

  splitByLab() {
    // 依照檢驗機構排序
    // this.hist.Hist.HRxs.sort((a, b) => {
    //   if (a.TransOri && b.TransOri) {
    //     return a.TransOri.localeCompare(b.TransOri);
    //   }
    //   return 0;
    // });
    // var prevLab = '';
    // var currentLab = '';
    // this.printOutByLab = [];
    this.hist.Hist.HRxs.forEach(item => {
      if (item.TransOri) {
        item.HsipId = this.labHospInfo.find(x => x.HID == item.TransOri);
      }
    });
    // 依照檢驗機構分組
    let groupTemp: HistOrder[] = [];
    const grouped = this.hist.Hist.HRxs.reduce((acc, item) => {
      const key = item.HsipId ? item.HsipId.HID : '';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as { [key: string]: HistOrder[] });
    this.printOutByLab = Object.values(grouped);
    // console.log('grouped', grouped);
    // debugger
  }

  dateString(input: Date): string {
    var d = new Date(input);
    var month = (d.getMonth() + 1);
    var day = d.getDate();
    var year = d.getFullYear();
    return year + '/' + month + '/' + day;
  }
  get dxNames() {
    return [this.hist?.Hist.Dx1Name, this.hist?.Hist.Dx2Name, this.hist?.Hist.Dx3Name,
    this.hist?.Hist.Dx4Name, this.hist?.Hist.Dx5Name, this.hist?.Hist.Dx6Name].filter(x => x).join(',');
  }
  get dxCodes() {
    // return [this.hist?.Hist.Dx1, this.hist?.Hist.Dx2, this.hist?.Hist.Dx3,
    // this.hist?.Hist.Dx4, this.hist?.Hist.Dx5, this.hist?.Hist.Dx6].filter(x => x).join(',');
    //return [this.hist?.Hist.Dx1, this.hist?.Hist.Dx2, this.hist?.Hist.Dx3,
    //this.hist?.Hist.Dx4, this.hist?.Hist.Dx5, this.hist?.Hist.Dx6].filter(x => x).join(',');
    return (this.wholeHist?.PrintDiagnosisCodes || []).join(',');
  }

  generateQRCode(text: string, type: number): void {
    QRCode.toDataURL(text, (err, url) => {
      if (err) {
        console.error(err);
        return;
      }
      // 将生成的二维码图片URL存储在一个变量中，或者直接在模板中使用
      // this.qrcodeImg.nativeElement.src = url;
      switch (type) {
        // 病歷
        case 1:
          this.qrcodeImg.nativeElement.src = url;
          break;
        //收據
        case 2:
          this.qrcode2Img.nativeElement.src = url;
          break;
        //就醫識別碼
        case 3:
          this.qrcodeItreatnumImg.nativeElement.src = url;
          this.qrcodeItreatnum2Img.nativeElement.src = url;
          break;
        //連處
        //連處
        default:
          break;
      }
    });
  }

}
